import { FilePreview } from '@components/Files/FilePreview';
import { useUploadContext } from '@components/Files/UploadProvider';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { BulkJobStep, useCurrentModalContext } from '../../providers/ModalProvider';

export const UploadFilesStep = () => {
  const { step, onCancel, error, isLoading, setStep } = useCurrentModalContext();
  const { files } = useUploadContext();

  const isThereBadFiles = !!files.find((f) => f.meta.extra?.analysisStatus !== 'done');

  if (step !== BulkJobStep.UploadFiles && step !== BulkJobStep.AnalyzingFiles) {
    return null;
  }

  const submit = async () => {
    setStep(BulkJobStep.CreateJobs);
  };

  return (
    <div className="step-wrapper">
      <div className="previews">
        {files.map((item, index) => {
          return (
            <div key={index} className="file-wrapper">
              <FilePreview item={item} allowRemove={item.meta.extra?.analysisStatus === 'error'} />
            </div>
          );
        })}
      </div>
      {error ? <div className="errorMessage">{error}</div> : null}
      <div className="buttonContainer">
        <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
        <Button className="ml-4" onClick={submit} disabled={isLoading || isThereBadFiles}>
          Continue
        </Button>
      </div>
    </div>
  );
};
